import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { AIAnalyticsStats } from '@/types/seeds';

interface AIStatsCardProps {
  stats: AIAnalyticsStats;
}

export function AIStatsCard({ stats }: AIStatsCardProps) {
  const costDollars = (stats.total_cost_cents / 100).toFixed(2);

  return (
    <Card>
      <CardHeader>
        <CardTitle>AI Usage Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
          <div>
            <p className="text-sm text-muted-foreground">Total Calls</p>
            <p className="text-2xl font-bold">{stats.total_interactions}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Success Rate</p>
            <p className="text-2xl font-bold">{stats.success_rate}%</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Tokens</p>
            <p className="text-2xl font-bold">{stats.total_tokens_used.toLocaleString()}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total Cost</p>
            <p className="text-2xl font-bold">${costDollars}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Avg Response</p>
            <p className="text-2xl font-bold">{Math.round(stats.avg_response_time_ms)}ms</p>
          </div>
        </div>

        {Object.keys(stats.by_type ?? {}).length > 0 && (
          <div className="mt-6">
            <h4 className="mb-2 text-sm font-medium">By Interaction Type</h4>
            <div className="space-y-2">
              {Object.entries(stats.by_type ?? {}).map(([type, ts]) => (
                <div key={type} className="flex items-center justify-between rounded-md border p-2 text-sm">
                  <span className="font-medium">{type}</span>
                  <div className="flex gap-4 text-muted-foreground">
                    <span>{ts.count} calls</span>
                    <span>{ts.success_rate}% success</span>
                    <span>~{Math.round(ts.avg_tokens)} tokens</span>
                    <span>{Math.round(ts.avg_response_ms)}ms</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
